import { Avatar } from "@mui/material";
import React from "react";
import { colorTheme } from "../../../utils/SOCUtils";
type Props = {
    pendingSoc?: string | number | null;
    width?: number;
    height?: number;
    type?: keyof typeof colorTheme
}


const SocCustomAvatar = (props: Props) => {
  const { pendingSoc="", width, height, type = "default" } = props;

  const { borderColor, bgColor, color } = colorTheme[type] || colorTheme["Current"];

  return (
    <div className="flex">
      <Avatar sx={{ width, height, border: type ? `1px solid ${borderColor}`: undefined,
        fontSize: "0.875rem", fontWeight: "600", background: bgColor, color: color }}
      >
        {pendingSoc}
      </Avatar>
    </div>
  );
};

export default SocCustomAvatar;
